// Cart Promo Code Application
document.addEventListener('DOMContentLoaded', function() {
  initPromoCodeApplication();
  
  // Fix for cart totals
  updateCartDisplayTotals();
  
  // Listen for cart updates from different sources
  document.addEventListener('cart:updated', updateCartDisplayTotals);
  window.addEventListener('cart:refresh', updateCartDisplayTotals);
  
  // Listen for Shopify's cart update events
  document.addEventListener('cart.requestComplete', updateCartDisplayTotals);
  
  // Periodic check for cart changes (every 2 seconds)
  setInterval(updateCartDisplayTotals, 2000);
});

// Utility function to safely get money format from various sources
function getMoneyFormat() {
  let moneyFormat = '${{amount}}'; // Default fallback
  
  // Try to get from Shopify global object first
  if (typeof window.Shopify !== 'undefined' && window.Shopify.money_format) {
    return window.Shopify.money_format;
  }
  
  // Try to get from cart data element
  const cartDataElement = document.querySelector('[data-section-type="static-cart"]');
  if (cartDataElement) {
    try {
      // Try multiple data sources for cart configuration
      let cartData = null;
      
      // First try dataset.sectionData
      if (cartDataElement.dataset.sectionData) {
        try {
          cartData = JSON.parse(cartDataElement.dataset.sectionData);
        } catch (e) {
          console.warn('Failed to parse dataset.sectionData:', e);
        }
      }
      
      // If that fails, try innerHTML
      if (!cartData && cartDataElement.innerHTML && cartDataElement.innerHTML.trim().startsWith('{')) {
        try {
          cartData = JSON.parse(cartDataElement.innerHTML);
        } catch (e) {
          console.warn('Failed to parse innerHTML:', e);
        }
      }
      
      // Apply money format if found in cartData
      if (cartData && cartData.settings && cartData.settings.money_format) {
        moneyFormat = cartData.settings.money_format;
      }
    } catch (e) {
      console.warn('Error getting money format from cart data:', e);
    }
  }
  
  return moneyFormat;
}

// Global formatMoney function - moved outside to be accessible from all functions
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';
  
  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
  
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    
    if (isNaN(number) || number == null) {
      return 0;
    }
    
    number = (number / 100.0).toFixed(precision);
    
    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';
    
    return dollarsAmount + centsAmount;
  }
  
  // Check if format string has a valid placeholder
  const match = formatString.match(placeholderRegex);
  if (!match) {
    return formatString; // Return original format if no placeholder found
  }
  
  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }
  
  return formatString.replace(placeholderRegex, value);
}

// Function to update the cart display totals with correct values
function updateCartDisplayTotals() {
  // Fetch the current cart data
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      const subtotalElements = document.querySelectorAll('[data-cart-subtotal]');
      const totalElements = document.querySelectorAll('[data-cart-final-total]');
      
      if (subtotalElements.length > 0 || totalElements.length > 0) {
        // Get money format using utility function
        const moneyFormat = getMoneyFormat();
        
        // Validate cart data before proceeding
        if (!cart || typeof cart !== 'object') {
          console.warn('Invalid cart data received:', cart);
          return;
        }
        
        // Format money values with fallback for undefined values
        const originalTotal = cart.original_total_price || cart.total_price || 0;
        const finalTotal = cart.total_price || 0;
        
        const formattedOriginalTotal = formatMoney(originalTotal, moneyFormat);
        const formattedFinalTotal = formatMoney(finalTotal, moneyFormat);
        
        // Update subtotal elements
        subtotalElements.forEach(element => {
          element.textContent = formattedOriginalTotal;
        });
        
        // Update total elements
        totalElements.forEach(element => {
          element.textContent = formattedFinalTotal;
        });
      }
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

function initPromoCodeApplication() {
  const applyButton = document.querySelector('.cart-sidebar-promo__apply-button');
  const promoInput = document.querySelector('.cart-sidebar-promo__input');
  const discountElement = document.querySelector('.cart-sidebar-promo__summary-row:nth-child(2) .cart-sidebar-promo__summary-value .money');
  const discountList = document.querySelector('[data-cart-sidebar-discounts]');
  
  if (!applyButton || !promoInput) return;
  
  // Get Shopify's money format using utility function
  const moneyFormat = getMoneyFormat();
  
  applyButton.addEventListener('click', function() {
    applyDiscount();
  });
  
  // Also allow Enter key to apply discount
  promoInput.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyDiscount();
    }
  });
  
  function applyDiscount() {
    const discountCode = promoInput.value.trim();
    if (!discountCode) {
      showMessage('Please enter a discount code.', 'error');
      return;
    }
    
    // Show loading state
    applyButton.disabled = true;
    applyButton.innerHTML = '<span>Applying...</span>';
    
    // Make a request to Shopify's cart update endpoint
    fetch('/discount/' + encodeURIComponent(discountCode), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html',
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Discount code application failed');
      }
      return fetch('/cart.js', { 
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Cart updated:', cart);
      
      // Update the discount amount if it exists
      if (cart.total_discount > 0) {
        // Format the discount amount using the Shopify money format
        const formattedDiscount = formatMoney(cart.total_discount, moneyFormat);
        if (discountElement) {
          discountElement.textContent = '-' + formattedDiscount;
        }
        
        // Update discount list if present
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          updateDiscountList(cart.cart_level_discount_applications);
        }
        
        // Update cart total if needed
        updateCartTotal(cart.total_price, moneyFormat);
        
        // Show success message
        showMessage('Discount applied successfully!', 'success');
        
        // Clear the input field after successful application
        promoInput.value = '';
      } else {
        // If no discount was applied, it may be an invalid code
        showMessage('Invalid or expired discount code.', 'error');
      }
      
      // Reload the page to refresh all cart elements
      // This ensures everything is properly updated including the discount list
      window.location.reload();
    })
    .catch(error => {
      console.error('Error applying discount:', error);
      showMessage('Error applying discount code. Please try again.', 'error');
    })
    .finally(() => {
      // Reset button state
      applyButton.disabled = false;
      applyButton.innerHTML = '<span>Apply</span>';
    });
  }
  
  function updateDiscountList(discountApplications) {
    if (!discountList) return;
    
    // Create container if it doesn't exist
    let container = discountList.closest('.cart-sidebar-promo__discounts');
    if (!container) {
      container = document.createElement('div');
      container.className = 'cart-sidebar-promo__discounts';
      const summaryElement = document.querySelector('.cart-sidebar-promo__summary');
      if (summaryElement && summaryElement.parentNode) {
        summaryElement.parentNode.insertBefore(container, summaryElement);
      }
      
      // Create the list
      const ul = document.createElement('ul');
      ul.className = 'discount-list';
      ul.setAttribute('data-cart-sidebar-discounts', '');
      ul.setAttribute('aria-label', 'Discounts');
      container.appendChild(ul);
      
      discountList = ul;
    }
    
    // Clear existing items
    discountList.innerHTML = '';
    
    // Add each discount application
    discountApplications.forEach(application => {
      const li = document.createElement('li');
      li.className = 'discount-list-item cart-discount';
      
      const titleSpan = document.createElement('span');
      titleSpan.className = 'cart-discount-title';
      
      // Add icon (this is a simplified version, you may need to adjust based on your icon system)
      titleSpan.innerHTML = '<svg viewBox="0 0 20 20" class="icon-sale-tag"><path d="M17.35,2.219h-5.934c-0.115,0-0.225,0.045-0.307,0.128l-8.762,8.762c-0.171,0.168-0.171,0.443,0,0.611l5.933,5.934c0.167,0.171,0.443,0.169,0.612,0l8.762-8.763c0.083-0.083,0.128-0.192,0.128-0.307V2.651C17.781,2.414,17.587,2.219,17.35,2.219M16.916,8.405l-8.332,8.332l-5.321-5.321l8.333-8.332h5.32V8.405z M13.891,4.367c-0.957,0-1.729,0.772-1.729,1.729c0,0.957,0.771,1.729,1.729,1.729s1.729-0.772,1.729-1.729C15.619,5.14,14.848,4.367,13.891,4.367 M14.502,6.708c-0.326,0.326-0.896,0.326-1.223,0c-0.338-0.342-0.338-0.882,0-1.224c0.342-0.337,0.881-0.337,1.223,0C14.84,5.826,14.84,6.366,14.502,6.708"></path></svg>';
      titleSpan.appendChild(document.createTextNode(application.title));
      
      const priceSpan = document.createElement('span');
      priceSpan.className = 'cart-discount-price';
      priceSpan.innerHTML = '-<span class="money">' + formatMoney(application.total_allocated_amount, moneyFormat) + '</span>';
      
      li.appendChild(titleSpan);
      li.appendChild(priceSpan);
      discountList.appendChild(li);
    });
    
    // Show the container
    container.style.display = 'block';
  }
  
  function updateCartTotal(totalPrice, format) {
    const totalElements = document.querySelectorAll('[data-cart-total], [data-cart-subtotal], [data-cart-final-total]');
    const formattedTotal = formatMoney(totalPrice, format);
    
    totalElements.forEach(element => {
      // For subtotal elements, use original price (before discounts)
      if (element.hasAttribute('data-cart-subtotal')) {
        // Note: This will be updated when the page refreshes with cart.original_total_price
        element.textContent = formattedTotal;
      } 
      // For other elements (total and final-total), use the price after discounts
      else {
        element.textContent = formattedTotal;
      }
    });
  }
  
  
  function showMessage(message, type) {
    // Create a message element if it doesn't exist
    let messageElement = document.querySelector('.cart-promo-message');
    if (!messageElement) {
      messageElement = document.createElement('div');
      messageElement.className = 'cart-promo-message';
      
      // Find the input container and insert the message after it
      const inputContainer = document.querySelector('.cart-sidebar-promo__input-row');
      if (inputContainer) {
        inputContainer.insertAdjacentElement('afterend', messageElement);
      } else {
        // Fallback to original behavior if container not found
        promoInput.parentNode.appendChild(messageElement);
      }
    }
    
    // Set message and type
    messageElement.textContent = message;
    messageElement.className = 'cart-promo-message cart-promo-message--' + type;
    
    // Automatically hide the message after 5 seconds
    setTimeout(() => {
      messageElement.style.opacity = '0';
      setTimeout(() => {
        messageElement.remove();
      }, 500);
    }, 5000);
  }
} 